import { render } from "./FeaturedProductName.vue?vue&type=template&id=cc156e86"
import script from "./FeaturedProductName.vue?vue&type=script&lang=js"
export * from "./FeaturedProductName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__